// extracted by mini-css-extract-plugin
export default {"textLine":"styles_textLine__xpgb+"};